import { FC } from 'react';
import { Button } from '@mui/material';
import { CheckCircle, PauseCircleFilled } from '@mui/icons-material';
import { useInvestorDisability } from 'hooks/data/investor/useInvestorDisability';
import { Row } from 'components/Layout';
import { useHasPermissions } from 'hooks/ui/usePermissions';
import { RolePermission } from 'further-types/admin-user-role';

interface Props {
  investorId: string;
  emailsCurrentlyDisabled: boolean;
}

const SingleFirmEmailToggle: FC<Props> = ({
  investorId,
  emailsCurrentlyDisabled,
}) => {
  const { mutate: updateInvestorDisability } = useInvestorDisability();
  const [canEdit] = useHasPermissions([RolePermission.EditInvestor]);

  return (
    <Row centered spacing="xs">
      {emailsCurrentlyDisabled ? (
        <>
          <PauseCircleFilled color="secondary" style={{ fontSize: '1rem' }} />
          <span>Disabled</span>
        </>
      ) : (
        <>
          <CheckCircle color="primary" style={{ fontSize: '1rem' }} />
          <span>Enabled</span>
        </>
      )}
      {canEdit && (
        <Button
          size="extra-small"
          variant="outlined"
          color="primary"
          onClick={() =>
            updateInvestorDisability({
              investorId,
              disableAllEmails: !emailsCurrentlyDisabled,
            })
          }
        >
          {emailsCurrentlyDisabled ? 'Enable emails' : 'Disable emails'}
        </Button>
      )}
    </Row>
  );
};

export default SingleFirmEmailToggle;
